import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import ParchmentBackground from '../../components/ParchmentBackground';
import '../../styles/LegalPage.css';

const HOME_URL = 'https://icraftz.com';

const Page = ({ eyebrow, title, subtitle, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = title ? `${title} — iCraftz` : 'iCraftz';
  }, [title]);

  return (
    <div className="legal-page">
      <ParchmentBackground />
      <header className="legal-topbar legal-topbar--split">
        <a
          href={HOME_URL}
          className="legal-home-link"
          data-testid="legal-topbar-logo"
        >
          iCraftz<sup>™</sup>
        </a>
        <a
          href={HOME_URL}
          className="legal-topbar-back"
          data-testid="legal-back-home-top"
        >
          <ArrowLeft size={14} /> Back to Home
        </a>
      </header>
      <main className="legal-main">
        <article className="legal-article">
          {eyebrow && <p className="legal-eyebrow">{eyebrow}</p>}
          <h1 className="legal-title">{title}</h1>
          {subtitle && <p className="legal-subtitle">{subtitle}</p>}
          <div className="legal-divider" />
          <div className="legal-body">{children}</div>

          <div className="legal-back-home-wrap">
            <a
              href={HOME_URL}
              className="legal-back-home-link"
              data-testid="legal-back-home-bottom"
            >
              ← Back to Home
            </a>
          </div>
        </article>
      </main>
      <footer className="legal-foot">
        <p>
          <Link to="/about">About</Link>
          <span> · </span>
          <Link to="/mission">Mission</Link>
          <span> · </span>
          <Link to="/partner">Partner</Link>
          <span> · </span>
          <Link to="/for-authors">For Authors</Link>
          <span> · </span>
          <Link to="/pricing">Pricing</Link>
          <span> · </span>
          <Link to="/contact">Contact</Link>
          <span> · </span>
          <Link to="/privacy">Privacy</Link>
          <span> · </span>
          <Link to="/terms">Terms</Link>
        </p>
        <p className="legal-foot-copy">© {new Date().getFullYear()} iCraftz™. Less Noise · More Thought.</p>
      </footer>
    </div>
  );
};

export default Page;
